<div
  class="full-page bg-black w-100"
  [style.background-image]="'url(' + ('login-registrations/registration-background.jpg' | contentAssetImage) + ')'"
>
  <div class="registration-layout-page-div">
    <ng-container *ngIf="wizardType === wizardTypes.ChildRegistration; else userRegistration">
      <img
        class="logo child-registration mx-auto w-100 text-center"
        height="100px"
        [src]="'logos/logo.svg' | contentAssetImage"
      />
    </ng-container>
    <ng-template #userRegistration>
      <img class="logo mx-auto w-100 text-center" [src]="'logos/nav-logo.png' | contentAssetImage" />
    </ng-template>
    <div class="reg-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
